export const isImageAttachment = (url) => !!url && /\.(png|jpe?g|gif|webp|bmp|svg|avif|heic|heif|tiff?|ico)$/i.test(url);

export const attachmentFileName = (url) => {
  if (!url) return '';
  try {
    return decodeURIComponent(new URL(url, window.location.origin).pathname.split('/').pop() || '');
  } catch (e) {
    return url.split('/').pop() || '';
  }
};
